const modal = {
  styleOverrides: {
    root: {
      "& .css-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
        backgroundColor: "rgba(0,0,0,0.1)",
      },
    },
  },
};
export default modal;
